import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import createPlugins from '@/store/modules/requests/history/plugins';
import BaseModule from '@/store/baseModule';

const attributesObjRef = {
  work_order_group_type_code: {
    serverSide: true,
    values: [],
  },
};

export default (store) => {
  store.registerModule(
    ['properties', 'qualifications'],
    new BaseModule({
      attributesObjRef,
      attributesObj: { national_symptom: { serverSide: true, values: ['N'] } },
      makeQueryParams: makeListRequest({}),
      makeHttpParamsUrl: (id) =>
        `${process.env.P2C_BASE_URI}/properties/${id}/work_order_group_qualifications`,
    })
  );
  createPlugins({
    module: 'properties/qualifications',
    store,
  });
};
